import type { MemoizedFn } from 'memoize-one';
import memoize from 'memoize-one';

import type { EventHandlers } from '@atlaskit/editor-common/EventHandlers';

import { isExternalShareRequest } from '@confluence/external-share-utils/entry-points/isExternalShareRequest.ts';
import type { RoutesContextType } from '@confluence/route-manager/entry-points/RoutesContext.ts';
import { getSpaTransitionDetails } from '@confluence/route-manager/entry-points/GlobalAnchorHandler.ts';
import { isExternalLink } from '@confluence/linking-platform/entry-points/isExternalLink.ts';

export const createLinkEventHandler: MemoizedFn<
	(routesContext: Pick<RoutesContextType, 'matchRoute' | 'push'>) => EventHandlers | undefined
> = memoize(
	(routesContext: Pick<RoutesContextType, 'matchRoute' | 'push'>): EventHandlers | undefined =>
		routesContext && typeof routesContext.push === 'function'
			? {
					link: {
						onClick(e, url) {
							const isInlineComment =
								e.target instanceof Element &&
								e.target.matches('[data-mark-annotation-type="inlineComment"]');
							if (isInlineComment) return;

							const details = getSpaTransitionDetails(e, routesContext);
							if (isExternalLink(url)) {
								e.preventDefault();
								window.open(url, '_blank', 'noopener, noreferrer');
							} else if (details?.href && details.href === url) {
								e.preventDefault();
								routesContext.push(details.href, isExternalShareRequest());
							}
						},
					},
				}
			: undefined,
);
